"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var Pagination = /** @class */ (function (_super) {
    __extends(Pagination, _super);
    function Pagination(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            pageCount: _this.calculatePageCount(),
            currentPage: 1
        };
        _this.handleClickPrevious = _this.handleClickPrevious.bind(_this);
        _this.handleClickNext = _this.handleClickNext.bind(_this);
        _this.handleClickPageNumber = _this.handleClickPageNumber.bind(_this);
        return _this;
    }
    Pagination.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.total !== this.props.total || prevProps.limit !== this.props.limit) {
            this.setState({
                pageCount: this.calculatePageCount()
            });
        }
        if (prevProps.offset !== this.props.offset || prevProps.limit !== this.props.limit) {
            this.setState({
                currentPage: this.calculateCurrentPage()
            });
        }
    };
    Pagination.prototype.render = function () {
        if (this.state.pageCount > 1) {
            var _a = this.state, currentPage = _a.currentPage, pageCount = _a.pageCount;
            return ((0, jsx_runtime_1.jsxs)("ul", { className: "pagination justify-content-center", children: [(0, jsx_runtime_1.jsx)("li", { className: "page-item", children: (0, jsx_runtime_1.jsx)("a", { className: "page-link ".concat(currentPage === 1 ? "disabled" : ""), onClick: this.handleClickPrevious, children: "Previous" }) }), this.renderPageNumbers(), (0, jsx_runtime_1.jsx)("li", { className: "page-item", children: (0, jsx_runtime_1.jsx)("a", { className: "page-link ".concat(currentPage === pageCount ? "disabled" : ""), onClick: this.handleClickNext, children: "Next" }) })] }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(React.Fragment, {});
        }
    };
    Pagination.prototype.handleClickPrevious = function () {
        if (this.state.currentPage !== 0) {
            this.props.onClickPrevious();
        }
    };
    Pagination.prototype.handleClickNext = function () {
        if (this.state.currentPage !== this.state.pageCount) {
            this.props.onClickNext();
        }
    };
    Pagination.prototype.handleClickPageNumber = function (event) {
        var pageNumber = event.target.dataset.number;
        if (pageNumber >= 1 && pageNumber <= this.state.pageCount) {
            this.props.onClickPageNumber(pageNumber);
        }
    };
    Pagination.prototype.calculatePageCount = function () {
        if (this.props.total > 0 && this.props.limit > 0) {
            return Math.ceil(this.props.total / this.props.limit);
        }
        return 1;
    };
    Pagination.prototype.calculateCurrentPage = function () {
        if (this.props.offset > 0 && this.props.limit > 0) {
            return Math.ceil(this.props.offset / this.props.limit) + 1;
        }
        return 1;
    };
    Pagination.prototype.renderPageNumbers = function () {
        var _a = this.state, currentPage = _a.currentPage, pageCount = _a.pageCount;
        var minPageToRender = 1;
        var maxPageToRender = pageCount;
        if (pageCount > 5) {
            if (currentPage > pageCount - 3) {
                minPageToRender = pageCount - 4;
            }
            else if (currentPage > 3) {
                minPageToRender = currentPage - 2;
                maxPageToRender = currentPage + 2;
            }
            else {
                maxPageToRender = 5;
            }
        }
        var pageNumbersToRender = [];
        if (minPageToRender > 1) {
            pageNumbersToRender.push((0, jsx_runtime_1.jsx)("li", { className: "page-item", children: (0, jsx_runtime_1.jsx)("a", { className: "page-link px-1", onClick: this.handleClickPrevious, children: "..." }) }, minPageToRender - 1));
        }
        for (var i = minPageToRender; i <= maxPageToRender; i++) {
            pageNumbersToRender.push((0, jsx_runtime_1.jsx)("li", { className: "page-item ".concat(i === currentPage ? "active" : ""), children: (0, jsx_runtime_1.jsx)("a", { className: "page-link ".concat(i === currentPage ? "disabled" : ""), "data-number": i, onClick: this.handleClickPageNumber, children: i }) }, i));
        }
        if (maxPageToRender < pageCount) {
            pageNumbersToRender.push((0, jsx_runtime_1.jsx)("li", { className: "page-item", children: (0, jsx_runtime_1.jsx)("a", { className: "page-link px-1", onClick: this.handleClickNext, children: "..." }) }, maxPageToRender + 1));
        }
        return pageNumbersToRender;
    };
    Pagination = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], Pagination);
    return Pagination;
}(React.Component));
exports.default = Pagination;
//# sourceMappingURL=Pagination.js.map